import React, { useEffect } from "react";
import { useRouter } from "next/router";
import AuthorData from "../../../data/authors.json";
import PageHead from "@/pages/Head";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";
import MobileMenu from "@/components/Header/MobileMenu";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
// import Cart from "@/components/Header/Offcanvas/Cart";
import BackToTop from "@/pages/backToTop";
import Separator from "@/components/Common/Separator";
import FooterOne from "@/components/Footer/Footer-One";
import BlogDetails from "@/components/Blogs/BlogDetails";
import BlogListItems from "@/components/Blogs/Blog-Sections/BlogList-Items";
import Instagram from "@/components/Instagram/Instagram";
import BlogBreadCrumb from "@/components/Common/Blog-BreadCrumb";
import CPStaticContent from '../../../models/CPStaticContent.js'

export default function SingleBlog(blog) {
  const router = useRouter();
  const blogId = router.query.blogId;

  const mdxSource = blog.content
  // const allBlogs = blog.list
  const blogInfo = blog.info

  const authors = JSON.parse(JSON.stringify(AuthorData.authorList));
  const Author = authors.find((author) => author.id === "akbar-hussain");

  blogInfo['position'] = "Blogs"
  blogInfo['author'] = [Author]
  const matchedBlog = blogInfo

  useEffect(() => {
    if (blogId && !matchedBlog) {
      router.push("/certification");
    }
  }, [matchedBlog, router]);

  return (
    <>
      <PageHead post={matchedBlog} />
      <Provider store={Store}>
        <Context>
          <MobileMenu />
          <HeaderStyleTen headerSticky="rbt-sticky" headerType="" />
          {/* <Cart /> */}

          <div className="rbt-overlay-page-wrapper">
            <BlogBreadCrumb blogType="blog" matchedBlog={matchedBlog} categoryName={"Certifications"} categoryPath={"/certifications"} />

            <div className="rbt-blog-details-area rbt-section-gapBottom breadcrumb-style-max-width">
              <div className="blog-content-wrapper rbt-article-content-wrapper">
                <BlogDetails
                  blogType={"blog"}
                  matchedBlog={matchedBlog !== undefined ? matchedBlog : ""}
                  blogContent={mdxSource}
                  author={Author}
                />
                <div className="related-post pt--60">
                  <div className="section-title text-start mb--40">
                    <span className="subtitle bg-primary-opacity">
                      continue reading
                    </span>
                    <h4 className="title">Other Blogs</h4>
                  </div>
                  <BlogListItems
                    blogType={"certification"}
                    selectedBlogs={blog.similar}
                    itemIdToAvoid={blogId}
                    start={0}
                    end={10}
                  />
                </div>
              </div>
            </div>

            <Instagram />
          </div>

          <BackToTop />
          <Separator />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export async function getStaticProps(context) {
  const stContent = new CPStaticContent("certification")
  await stContent.fetchContent()
  return await stContent.getItemProps(context.params.postId)
}

export async function getStaticPaths(context) {
  const stContent = new CPStaticContent("certification")
  await stContent.fetchContent()
  const paths = await stContent.getPaths()
  return { paths, fallback: false }
}


